import React from 'react';
import * as Styles from './AgentWelcome.styles';
import BannerWomanChatEs from '@/media/icons/agentwelcome/banner_woman_chat_es.png';
import BannerWomanChatBr from '@/media/icons/agentwelcome/banner_woman_chat_br.png';
import HeartMessageIcon from '@/media/icons/agentwelcome/heart_message.svg';
import ArrowUpGraphIcon from '@/media/icons/agentwelcome/arrow_up_graph.svg';
import circlesImage from '@/media/onboarding/aiBuilder/circles-to-background.png';
import starImage from '@/media/onboarding/aiBuilder/star-to-background.png';
import {
  Button, IconArrow, IconClock, IconGift,
} from 'gatorcomponents';
import { isBRServer } from '@/utils/Validators/validation';

const benefitIcons = [
  <IconClock key="clock" size="md" color="primaryMedium" />,
  HeartMessageIcon,
  ArrowUpGraphIcon,
];

const getBannerByLanguage = () => (isBRServer ? BannerWomanChatBr : BannerWomanChatEs);


export const AgentWelcome = ({ locales, onContinue }) => {
  const BannerWomanChat = getBannerByLanguage();

  return (
    <Styles.Wrapper>
      <Styles.WaveTop>
        <Styles.CirclesImage src={circlesImage} alt="loading-circles" />
        <Styles.StarImage src={starImage} alt="loading-star" />
      </Styles.WaveTop>
      <Styles.AgentWelcomeWrapper>
        <Styles.ImageWrapper>
          <img src={BannerWomanChat} alt={locales.presentation} />
        </Styles.ImageWrapper>
        <Styles.ContentWrapper>
          <Styles.Badge>
            <IconGift color="highPure" secondaryColor="primaryMedium" size="sm" testId="gift-icon" />
            {locales.badge}
          </Styles.Badge>
          <Styles.Title>{locales.title}</Styles.Title>
          <Styles.BenefitsWrapper>
            {locales.benefits.map((benefit, index) => {
              const BenefitIcon = benefitIcons[index];
              const isReactComponent = typeof BenefitIcon !== 'string';
              return (
                <Styles.BenefitItem key={benefit}>
                  <Styles.IconWrapper>
                    {isReactComponent ? BenefitIcon : <img src={BenefitIcon} alt="" />}
                  </Styles.IconWrapper>
                  <Styles.BenefitText>{benefit}</Styles.BenefitText>
                </Styles.BenefitItem>
              );
            })}
          </Styles.BenefitsWrapper>
          <Styles.Description>{locales.description}</Styles.Description>
          <Styles.ButtonWrapper>
            <Button
              variant="primary"
              label={locales.button}
              testId="create-site-agent-button"
              size="large"
              iconRight={<IconArrow direction="right" color="highPure" />}
              onClick={onContinue}
            />
          </Styles.ButtonWrapper>
        </Styles.ContentWrapper>
      </Styles.AgentWelcomeWrapper>
    </Styles.Wrapper>
  );
};
